<template>
  <v-dialog v-model="dialog" width="511">
    <v-card class="back-white border-white" height="300">
      <v-card-title class="back-556C96 justify-center">
        <h3 class="color-white">{{ companyId ? "업체 수정" : "업체 추가" }}</h3>
      </v-card-title>
      <v-row align="center" class="ma-0 pt-5 mt-3 ml-5">
        <div class="pl-2   width-150">
          <span>
            업체권한
          </span>
          <span class="required-text">
            (필수*)
          </span>
        </div>
        <div>
          <v-select
            class="border-width"
            :items="companyList"
            v-model="companyState"
            solo
            flat
            dense
            :menu-props="{ offsetY: true }"
          />
        </div>
      </v-row>
      <v-row align="center" class="ma-0 pt-3 mt-3 ml-5">
        <div class="width-150 pl-2  ">
          <span>업체명</span>
          <span class="required-text">
            (필수*)
          </span>
        </div>
        <input class="border-width" v-model="companyName" />
      </v-row>
      <v-row justify="center" align="center" class="ma-0 mt-5 pt-5">
        <v-btn
          width="140"
          height="38"
          color="#739EEC"
          class="color-white mr-3"
          @click="uporCreated"
        >
          등록완료
        </v-btn>
        <v-btn
          width="140"
          height="38"
          color="#ffffff"
          class="btn-ff5b5a "
          @click="deleteToCompany"
          v-if="companyId"
        >
          삭제
        </v-btn>
        <v-btn
          width="140"
          height="38"
          color="#eeeeee"
          @click="dialog = false"
          v-else
        >
          닫기
        </v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import CompanyApi from "@/api/CompanyService";
export default {
  data: () => ({
    companyList: ["샵업체", "가공업체", "관리자"],
    companyState: "",
    companyManager: "",
    managerPhone: "",
    companyName: "",
    dialog: false,
    companyId: "",
  }),
  async created() {
    this.$bus.$on("addCompanyOn", (value) => {
      this.companyId = value;
      this.dialog = true;
    });
  },
  beforeDestroy() {
    this.$bus.$off("addCompanyOn");
  },
  watch: {
    companyId(value) {
      if (value) this.findCompanyInfomation();
      else {
        this.companyName = "";
        this.companyState = "";
      }
    },
  },
  methods: {
    deleteToCompany() {
      this.dialog = false;
      this.$bus.$emit("confirmOn", "company", this.companyId);
    },
    async findCompanyInfomation() {
      let data = {
        companyId: this.companyId,
      };
      let returnData = await CompanyApi.companyInformation(data);
      let result = returnData.data.companyList;
      this.companyName = result.companyName;
      this.companyState = result.companyType;
    },
    async uporCreated() {
      let data = {
        companyId: this.companyId,
        companyName: this.companyName,
        companyType: this.companyState,
      };
      if (this.companyName.length < 1) {
        this.$bus.$emit("dialog", "회사명을 입력해주세요.");
        return;
      }
      let text = "";
      if (this.companyId) {
        let result = await CompanyApi.companyUpdate(data);
        if (result.data.success == "ok") text = "변경이 완료되었습니다.";
        else text = "동일한 회사명이 존재합니다.";
      } else {
        let result = await CompanyApi.companyCreate(data);
        if (result.data.success == "ok") text = "등록이 완료되었습니다.";
        else text = "동일한 회사명이 존재합니다.";
      }
      this.$bus.$emit("dialog", text);
      this.$bus.$emit("constructionNavigationDuplicated");
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.padding-20 {
  padding-bottom: 20px;
}

h3 {
  color: black;
  font-size: 20px;
}

.border-radius {
  border-radius: 10px;
}

.border-width {
  width: 212px;
  height: 42px;
  border: thin solid #aaaaaa;
}

.width-150 {
  width: 150px;
}
</style>
